import { mapState, mapGetters, mapMutations } from 'vuex'
import { Loading } from 'element-ui'
import { createOrder } from '@/api/index'
import { getUserInfo } from '@/api/user'
const tappaySetupOptions = {
  fields: {
    number: {
      element: '.form-control.card-number',
      placeholder: '**** **** **** ****'
    },
    expirationDate: {
      element: '#tappay-expiration-date',
      placeholder: 'MM / YY'
    },
    ccv: {
      element: '.form-control.cvc',
      placeholder: '後三碼'
    }
  },
  styles: {
    input: {
      'font-size': 'initial',
      color: 'gray'
    },
    ':focus': {
      color: 'black'
    },
    '.valid': {
      color: 'green'
    },
    '.invalid': {
      color: 'red'
    }
  }
}
export default {
  name: 'CartPayment',
  props: {
    code: {
      type: Object,
      required: true
    },
    shippingMethod: {
      type: Number,
      required: true
    },
    newCouponId: {
      type: String,
      required: false
    },
    details: {
      type: Object,
      required: true
    },
    Userlv: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      show_go_to_line: true,
      disabled: true,
      cardType: '卡號',
      status: { number: 1, expiry: 1, cvc: 1 },
      statusClass: ['has-success', '', 'has-error'],
      loading: '',
      tappayIframeLoadedNums: 0
    }
  },
  computed: {
    btnStyleClass() {
      return this.disabled ? 'btn-secondary' : 'btn-primary'
    },
    ...mapState('cart', ['cart']),
    ...mapGetters('cart', ['total'])
  },
  methods: {
    tappay() {
      TPDirect.setupSDK(
        13118,
        'app_lVKcbm5BkAgfJjUDPQpPTT2v7FISvWWvaKdunCsXV5GtwhTGKGzqcKRLHeEY',
        'production'
      )
      // set style
      TPDirect.card.setup(tappaySetupOptions)

      // listen for TapPay Field
      TPDirect.card.onUpdate(update => {
        this.disabled = !update.canGetPrime
        this.cardType = update.cardType === 'unknown' ? '卡號' : update.cardType
        this.status = { ...update.status }
      })
    },
    ...mapMutations('cart', ['resetCart']),
    openLodaing(text) {
      const loadingOption = { text }
      this.loading = Loading.service(loadingOption)
    },
    goBack() {
      this.$router.go(-1)
    },
    openAlert(content, title) {
      this.$alert(content, title, {
        confirmButtonText: '確認',
        callback: action => {
          // // this.$router.push({ name: 'entry' })
          // this.$router.push({ name: 'cart' })
        },
        dangerouslyUseHTMLString: true,
        customClass: 'myAlert'
      })
    },
  },
  created() {
    this.$emit('setStep', 3)
    console.log(this.code)

    // this.$emit('setShippingMethod', 2)
    // 自動回預約頁
    if (!this.details) {
      this.$router.replace({ name: 'info' })
    }
    console.log('this.newCouponId', this.newCouponId)


    if (this.newCouponId) {
      console.log("正確")
      let html = `
      <style>
      .myAlert .el-message-box__btns{text-align: center; }
      .myAlert .el-button{width:100px}
      </style>
      <div style="text-align:center">
        <div style="color:red;font-weight: 400;font-size: 20px;">恭喜您獲得！</div>
        <div style="font-size: 18px;margin: 35px 0 35px 0;">掌櫃優惠券「現金折扣券50元」</div>
        <div style="background-color: #9e9e9e3d;color: black;margin: 15px;line-height: 2;">
          <div style="font-size: 23px;">您的優惠券：${this.newCouponId}</div>
          <div>使用期限：2020/02/28</div>
        </div>
      </div>
      <div style="font-size: 18px;margin: 35px 0 15px 0;">
      使用說明：
      </div>
      <div style="font-size: 16px;margin-bottom: 50px;">
      您無須記下此優惠碼，您下次選擇「掌櫃寄件」時，系統會自動幫您選擇此優惠券。
      </div>
      `
      this.openAlert(html, '')
    }else if (this.Userlv === 0) {
      let img_ = require(`@/assets/join_us_line.png`);
      let html = `
      <style>
      .myAlert .el-message-box__btns{text-align: center; }
      .myAlert .el-button{width:100px}
      </style>
      <div style="text-align:center">
        <a href="https://line.me/R/ti/p/4qEAShuHxJ" target="_blank">
        <img src="${img_}" style="width:85%"/>
        </a>
      </div>
      `
      this.$alert(html, '', {
        confirmButtonText: '確認',
        callback: action => {
          window.open("https://line.me/R/ti/p/4qEAShuHxJ", "_blank")
        },
        dangerouslyUseHTMLString: true,
        customClass: 'myAlert'
      })
    }

    getUserInfo({userTel: this.details.userTel}).then(res=>{
      if(res.data.lineID != null && res.data.lineID != "") {
        this.show_go_to_line = false
      }
    })
    // this.openLodaing()

  },
  mounted() {
  }
}
